module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-saver-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModified) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "page-saver--message notranslate"
  }, [(_vm.changeCount > 0) ? _c('p', [
    [_vm._v("\n              " + _vm._s(_vm.$tc('ui.pages.lead-change-count', _vm.changeCount, {
      num: ("" + _vm.changeCount)
    })) + "\n            ")]
  ], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-saver--actions actions"
  }, [_c('button', {
    staticClass: "btn btn-flat btn-cancel",
    attrs: {
      "data-action": "item.cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "data-action": "item.update"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27a5ea0f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/PageSaver.vue
// module id = 1845
// module chunks = 0